import { useEffect, useState, useRef } from 'react';

// Default to same-origin (the ingress routes /ws -> backend). Local dev sets
// REACT_APP_WS_URL explicitly (e.g. ws://localhost:8000).
const WS_URL =
  process.env.REACT_APP_WS_URL ||
  `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}`;

export function useWebSocket(endpoint) {
  const [status, setStatus] = useState('disconnected');
  const [lastMessage, setLastMessage] = useState(null);
  const ws = useRef(null);

  useEffect(() => {
    const connect = () => {
      try {
        ws.current = new WebSocket(`${WS_URL}/ws/${endpoint}`);

        ws.current.onopen = () => {
          console.log('WebSocket connected');
          setStatus('connected');
        };

        ws.current.onmessage = (event) => {
          setLastMessage(event.data);
        };

        ws.current.onerror = (error) => {
          console.error('WebSocket error:', error);
          setStatus('error');
        };

        ws.current.onclose = () => {
          console.log('WebSocket disconnected');
          setStatus('disconnected');

          // Attempt to reconnect after 3 seconds
          setTimeout(() => {
            if (ws.current?.readyState === WebSocket.CLOSED) {
              connect();
            }
          }, 3000);
        };
      } catch (error) {
        console.error('Failed to connect WebSocket:', error);
        setStatus('error');
      }
    };

    connect();

    // Cleanup on unmount
    return () => {
      if (ws.current) {
        ws.current.close();
      }
    };
  }, [endpoint]);

  const sendMessage = (message) => {
    if (ws.current?.readyState === WebSocket.OPEN) {
      ws.current.send(JSON.stringify(message));
    }
  };

  return {
    status,
    lastMessage,
    sendMessage,
  };
}